import React from 'react'
import PropTypes from 'prop-types'

import { formTypes } from 'utils/constants/formTypes'
import { Text } from 'components/text/Text'

import styles from './SignatureTextByState.module.scss'

export const SignatureTextByState = ({ type }) => {
  if (type === formTypes.CT_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I hereby authorize the entities I have listed in this form to release required information pursuant to
          (C.G.S.) § 10-222c along with any related records. <br />
          I hereby consent to and authorize disclosure by the State Department of Education of the information requested
          pursuant to C.G.S. § 10-222c, as amended by Public Act 16-67, and I hereby authorize the release by the State
          Department of Education of any related records.
          <br />
          I further hereby release the above-named employer(s) and the State Department of Education from any and all
          liability of any kind that may arise from the disclosure or release of records requested pursuant to C.G.S. §
          10-222c, as amended by Public Act 16-67.
          <br />
        </Text>
      </div>
    )
  }

  if (type === formTypes.PA_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          By signing this form, I certify under penalty of law that the statements made in this form are correct,
          complete, and true to the best of my knowledge. I understand that false statements herein, including, without
          limitation, any willful failure to disclose the information required, shall subject me to criminal prosecution
          under 18 Pa.C.S. § 4904 (relating to unsworn falsification to authorities) and to discipline up to, and
          including, termination or denial of employment, and may subject me to civil penalties and disciplinary action
          under the Educator Discipline Act.
          <br />
          <br />I also hereby authorize the above-named employers to release to the entity listed on page 3, the
          information requested in this form and any related records. I hereby release, waive, and discharge the
          above-named employers from any and all liability of any kind that may arise from such disclosure or release of
          records. I understand that third party vendors may be used to process this Act 168 pre-employment history
          review.
        </Text>
      </div>
    )
  }

  if (type === formTypes.UT_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I understand and acknowledge that this authorization and release of information by the aforementioned entities
          or individuals can involve my competency, qualifications, performance, credentials, behaviors, or other
          characteristics or factors affecting my suitability for employment with the School. Additionally, I am
          authorizing the release of information about my performance, experience, capability, attitude, and/or other
          work-related characteristics or traits affecting my ability to directly care for, supervise, control, or have
          custody of a child, with such information currently in the possession of the following organizations, their
          management, employees, board members, representatives or assigns. <br /> <br />
          I agree not to file or pursue any complaints, claims, or legal actions against the School or any of its
          employees, representatives, or agents arising out of their efforts to obtain the aforementioned work-related
          information about me.
          <br /> <br />
          Furthermore, I understand that pursuant to Utah Code 53G-11-410, an LEA (the School) may not hire an LEA
          Applicant who does not sign a release described in 53G-11-410 (2)(a)(i) or (iii).
        </Text>
      </div>
    )
  }

  if (type === formTypes.AZ_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I understand and acknowledge that this authorization and release of information by the aforementioned entities
          or individuals can involve my competency, qualifications, performance, credentials, behaviors, or other
          characteristics or factors affecting my suitability for employment with the School. Additionally, I am
          authorizing the release of information about my performance, experience, capability, attitude, and/or other
          work-related characteristics or traits affecting my ability to directly care for, supervise, control, or have
          custody of a child, with such information currently in the possession of the following organizations, their
          management, employees, board members, representatives or assigns.
          <br /> <br />I agree not to file or pursue any complaints, claims, or legal actions against the School or any
          of its employees, representatives, or agents arising out of their efforts to obtain the aforementioned
          work-related information about me. Arizona Revised Statutes Section 15-512 requires of all Arizona school
          districts that “before employment with the School District, the District shall make documented, good faith
          efforts to contact previous employers of a person to obtain information and recommendations which may be
          relevant to a person’s fitness for employment.
        </Text>
      </div>
    )
  }

  if (type === formTypes.OR_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I authorize release to the employers listed in the form, all information related to any substantiated reports
          of child abuse, sexual conduct, or crimes listed in{' '}
          <a href="https://www.oregonlaws.org/ors/339.374" target="_blank" rel="noopener noreferrer">
            ORS 339.374.
          </a>
          <br />
          <br />I release the above employers and employees acting on behalf of the employers from any liability for
          providing information described in this document.
        </Text>
      </div>
    )
  }

  if (type === formTypes.CA_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I authorize release to the employers listed in the form, all information related to any substantiated reports
          of child abuse, sexual conduct, or crimes listed in{' '}
          <a
            href="https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202320240AB2534"
            target="_blank"
            rel="noopener noreferrer">
            California Assembly Bill (AB2534).
          </a>
          <br />
          <br />I release the above employers and employees acting on behalf of the employers from any liability for
          providing information described in this document.
        </Text>
      </div>
    )
  }

  if (type === formTypes.DC_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I authorize/consent that the employers I’ve provided may disclose my employment history records and I release
          them from any liability that may arise from the disclosure or release of these records.
        </Text>
      </div>
    )
  }

  if (type === formTypes.NM_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text size={18} weight="bold">
          <b>Required Background Information Pursuant to NM HB128</b>
        </Text>
        <br /> <br />
        <Text>
          I understand that this information shall not be deemed a public record. I acknowledge and understand that any
          actions taken in reliance on this information cannot be reversed, and my revocation of this authorization will
          not affect those actions. I hereby release ESS from all criminal and civil liability for the disclosure of the
          information that may arise from the disclosure or release of the records as requested by ESS unless the
          information or records provided by you were knowingly false.
        </Text>
      </div>
    )
  }

  if (type === formTypes.MI_EMPLOYMENT_REFERENCE) {
    return (
      <div className={styles.container}>
        <Text>
          I acknowledge ESS&apos;s right to investigate any and all references and secure additional information
          regarding my employment history, including any and all disciplinary action and/or the events surrounding the
          termination of employment.
          <br /> <br />
          Pursuant to Public Act 189 of 1996, I waive my right of prior notice under the Bullard-Plawecki Employee Right
          to Know Act, Act No. 397 of the Public Acts of 1978, being section 423.506 of Michigan Compiled Laws and I
          hereby release my current and former employer, and employees acting on behalf of my current and former
          employer, from any liability for providing information regarding connection with this employment history
          verification.
        </Text>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Text>
        By signing this form, I certify under penalty of law, that the statements above are correct, complete, and true
        to the best of my knowledge. I understand that false statements herein; including, without limitation, any
        willful failure to disclose the information required, shall subject me to criminal prosecution and to discipline
        up to and including termination or denial of employment even after employment begins and relevant information is
        subsequently discovered.
        <br /> <br />
        I hereby authorize the above-named employers to release to the entity: the information provided for
        current/former employers and any related records.
        <br />
        <br />I hereby release, waive, and discharge the above-named employers from any and all liability of any kind
        that may arise from such disclosure or release of records.
      </Text>
    </div>
  )
}

SignatureTextByState.propTypes = {
  type: PropTypes.string.isRequired,
}
